import './web.config';
// polyfill import must be up the top
import 'core-js';
import 'core-js/features/url-search-params';
import 'regenerator-runtime/runtime';

import './scss/app.scss';
import './scss/rte.scss';

// import '@rsl/frontend-foundation/Common/js/util/appLocationCookies';
// import setWindowCookie from '@rsl/frontend-foundation/Common/js/util/cookie';
// import './js/util/android-keyboard';
import after_polyfills_load from '../../Common/js/util/load-polyfills';
import '../../Common/js/util/environment';
import '../../Common/js/util/attributeHelper';
import '../../Common/js/util/focus';
import '../../Common/js/util/debouncer';
import '../../Common/modules/form-input/form-input';
import '../../Common/modules/accordion/accordion';

import './modules/search/search';
// import './modules/image-quote/image-quote';

// import './modules/membership/membership';
// import './modules/addthis/addthis';
import './modules/analytics/analytics';

//RSL
import './js/util/anchor-scroll';
import './modules/dropdown/dropdown';
import './modules/forms/forms';
import './modules/skip-link/skip-link';
import './modules/video/video';
import './js/util/iframe-addons';

import responsiveImage from './js/util/responsive-image';

// import '../../RSLQLD/source/modules/header/primary-nav'; //TODO: refactor later, if the BE header is combined, atm BE is serving a duplicated header for M4M compare to RSLQLD
import './modules/header/primary-nav-refactored';
import './modules/map/map';
import './modules/layout/_layout';

//Listing pages
import './modules/filter/filter';
import './modules/sentence-dropdown/sentence-dropdown';
import './modules/guided-services/guided-services'; //TODO: this should be refactored, it contains a lot of extra stuff not needed for M4M

import './modules/override-RSLQLD/override_RSLQLD_header';
import * as section from './modules/section/section';
import './modules/tile/tile';

import './modules/application-form/application-form';

//Note that polyfills will not start loading until this is run
after_polyfills_load(() => {
  // Run code in here that depends on the polyfills loading first
});

// setWindowCookie();
responsiveImage();
section.renderOverlappingSection();
section.renderFeaturedTilesSection();
section.renderFeaturedListSection();
section.renderTeamTilesSection();
section.renderFilterSection();
section.renderSectionWithoutSpacing();

const tables = document.querySelectorAll('table');

if (tables) {
  for (let i = 0, l = tables.length; i < l; i++) {
    tables[i].parentElement.classList.add('has-table');
  }
}
